import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Wybierz swój plan startowy <br/> My zajmujemy się wszystkim, <underline>TY</underline> odpoczywasz 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Zapłać później ze sprzedaży',
    [BillingMode.Stripe]: '(0)[Zapłać teraz];(1-inf)[Zapłać teraz (oszczędź do {{discount}})]',
  },
};
